const trunicateString = (maxLen, text) => {
        return (text.length > maxLen) ? text.substr(0, maxLen-1) + '\u2026' : text;
}
export default trunicateString;